module.exports = __webpack_public_path__ + "static/media/adène-médico-technique.546aef6b.png";